import React from 'react'

import { FILE_ICONS, IMAGE_EXTENSIONS } from '@elo-kit/constants/files.constants'

import { getBackgroundImageCss } from '@elo-kit/utils/themes.utils'
import { getFileExtension } from '@elo-kit/utils/files.utils'

const CommunityFilePreviewIcon = ({ file }) => {
  const { name, fileFileName, videoLink, cover, thumb, url, icon, wistiaData, imgUrl, cdnUrl } = file

  const previewUrl = videoLink ? cover : thumb || url || icon || imgUrl || cdnUrl
  const videoName = (wistiaData || {}).name
  const fileExtension = (videoName || fileFileName || name) && getFileExtension(fileFileName || name).toLowerCase()

  const isImage = (extension) => IMAGE_EXTENSIONS.some((item) => item === extension)

  const hasPreview = isImage(fileExtension) || videoLink

  const previewImage = previewUrl ? (
    <div
      className='file-item-preview image'
      style={{
        backgroundImage: getBackgroundImageCss(previewUrl),
      }}
    />
  ) : (
    <div className='file-item-preview'>
      <i className='fas fa-camera' />
    </div>
  )

  return (
    <>
      {hasPreview ? (
        previewImage
      ) : (
        <div className='file-item-preview icon'>
          <i className={FILE_ICONS[fileExtension] || 'fas fa-file'} />
        </div>
      )}
    </>
  )
}

export default CommunityFilePreviewIcon
